<div class="modal-header" ngxModalDraggable>
  <h4 class="modal-title">{{manufacturedItemGroup?.DisplayName}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.dismiss()">
  </button>
</div>
<div class="modal-body">
  <ime-manufactured-item-group-edit (changed)="onChanged($event)"
                                    (setTab)="currentTab = $event"
                                    [manufacturedItemGroup]="manufacturedItemGroup"
                                    [response]="response"
                                    [selectedTab]="currentTab"
                                    [scrollIntoViewId]="scrollIntoViewId"
                                    [shouldResetSaveState$]="shouldResetSaveState$"
                                    [wasValidated$]="wasValidated$"
                                    [readonly]="manufacturedItemGroup?.StatusClv === Classificators.ItemGroupStatus.Final">
  </ime-manufactured-item-group-edit>
</div>
<mes-web-edit-modal-buttons [entityId]="entityId"
                            [hasDeleteButton]="!!entityId"
                            [hasForceSaveButton]="isForceSaveShown"
                            [isPristine]="isPristine$ | async"
                            [displayName]="manufacturedItemGroup?.DisplayName"
                            [requiredPrivileges]="[PRIVILEGES.EditManufacturing]"
                            (deleteClick)="delete()"
                            (saveClick)="save($event)"
                            (forceSaveClick)="forceSave()"
                            (addClick)="add()"
                            (cancelClick)="bsModalRef.dismiss()">
</mes-web-edit-modal-buttons>
